class Card {
    constructor(deck, type, category, name, age, text, effects)
    {
        this.deck = deck;
        this.type = type;
        this.category = category;
        this.name = name;
        this.age = age;
        this.text = text;
        this.effects = effects;
    }
}

module.exports = Card;